import Link from "next/link";
import { useRouter } from "next/router";
import { Nav } from "react-bootstrap";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getLink from "src/functions/getLink";
import Facebook from "src/icons/Facebook";
import Instagram from "src/icons/Instagram";
import Youtube from "src/icons/Youtube";
import { sMenuFooter } from "src/styles/sMenuFooter.module.scss";
import { sMenuFooterLink } from "src/styles/sMenuFooterLink.module.scss";

function MenuFooter() {
  const { locale: lang } = useRouter();
  return (
    <Nav className={sMenuFooter}>
      <Nav.Item>
        <Link href={`https://anandita.cz/`} passHref>
          <Nav.Link
            eventKey={`anandita-yoga`}
            className={sMenuFooterLink}
            target="_blank"
          >
            <Translate tKey={`Anandita`} />
            <div>
              <Translate tKey={`Yoga`} />
            </div>
          </Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href={getLink(lang, `terms-and-privacy`, null)} passHref>
          <Nav.Link eventKey={`terms-privacy`} className={sMenuFooterLink}>
            <Translate tKey={`Terms`} />
            <div style={{ fontFamily: constants.Type.light }}>{`&`}</div>
            <Translate tKey={`Privacy`} />
          </Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href={getLink(lang, `contacts`, null)} passHref>
          <Nav.Link eventKey={`contacts`} className={sMenuFooterLink}>
            <Translate tKey={`Contacts`} />
          </Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href={constants.Social.instagramLink} passHref>
          <Nav.Link
            eventKey={`instagram`}
            target="_blank"
            className={sMenuFooterLink}
          >
            <Instagram />
          </Nav.Link>
        </Link>
        <Link href={constants.Social.facebookLink} passHref>
          <Nav.Link
            eventKey={`facebook`}
            target="_blank"
            className={sMenuFooterLink}
          >
            <Facebook />
          </Nav.Link>
        </Link>
        <Link href={constants.Social.youtubeLink} passHref>
          <Nav.Link
            eventKey={`youtube`}
            target="_blank"
            className={sMenuFooterLink}
          >
            <Youtube />
          </Nav.Link>
        </Link>
      </Nav.Item>
    </Nav>
  );
}

export default MenuFooter;
